import React, { useState } from "react";
import configContext from "./configContexts";

export default function ConfigContextProvider(props) {
  const [progress, setProgress] = useState(0);
  const [file, setFile] = useState(null);
  const [language, setLanguage] = useState(
    ["en", "mr"].includes(localStorage.getItem("language"))
      ? localStorage.getItem("language")
      : "en"
  );
  const switchLanguage = () => {
    setLanguage((prev) => (prev === "en" ? "mr" : "en"));
  };

  return (
    <configContext.Provider
      value={{ progress, setProgress, file, setFile, language, switchLanguage }}
    >
      {props.children}
    </configContext.Provider>
  );
}
